import { useRequest } from 'ahooks';
import { Descriptions, Drawer, Form, Spin } from 'antd';
import { isNil } from 'lodash';
import React, { FC, useState } from 'react';
import styles from './index.module.scss';
import { apiV2DispatchUetStructPublishGridAccessPointGetPost } from '@maxtropy/intelligent-dispath-apis-v2';
import ShowInput from '@/components/ShowInput';
import { NodeType, VoltageLevel, VoltageLevelLabel } from '@/pages/EnergyDispatchManagement/ElementCreationModal/types';
import TitleTag from '../TitleTag';

export interface GridAccessPointDrawerProps {
  isShowModal: (open: boolean) => void;
  open: boolean;
  id?: number;
  version?: number;
}

const { Item } = Form;

const GridAccessPointDrawer: FC<GridAccessPointDrawerProps> = props => {
  const { isShowModal, open, id, version } = props;

  const [form] = Form.useForm();
  const [title, setTitle] = useState<string>();

  const { loading } = useRequest(
    async () => {
      if (isNil(id) || !open) return Promise.resolve(undefined);
      if (!isNil(version)) {
        const detail = await apiV2DispatchUetStructPublishGridAccessPointGetPost({ id, version });
        form.setFieldsValue({
          ...detail,
          NodeTypeName: '电网接入点',
          voltageLevel: VoltageLevelLabel[detail.voltageLevel as VoltageLevel],
          uetName: detail.uet?.name,
          relationCircuitList: detail.circuitList?.map(i => i.name).join(),
        });
        setTitle(detail.name);
      }
    },
    {
      refreshDeps: [id, open, version],
    }
  );

  return (
    <div className={styles.drawerStyle}>
      <Drawer
        title={<TitleTag title={title ?? '电网接入点'} nodeType={NodeType.SOURCE} />}
        placement="right"
        width={400}
        mask={false}
        onClose={() => {
          isShowModal?.(false);
        }}
        open={open}
        getContainer={false}
      >
        <Spin spinning={loading}>
          <Form form={form}>
            <Descriptions labelStyle={{ width: '40%' }} title={null} bordered column={1} size="small">
              <Descriptions.Item label="元素类型">
                <Item name="NodeTypeName" style={{ marginBottom: 0 }}>
                  <ShowInput />
                </Item>
              </Descriptions.Item>
              <Descriptions.Item label="接入点名称">
                <Item name="name" style={{ marginBottom: 0 }}>
                  <ShowInput />
                </Item>
              </Descriptions.Item>
              <Descriptions.Item label="电压等级">
                <Item name="voltageLevel" style={{ marginBottom: 0 }}>
                  <ShowInput />
                </Item>
              </Descriptions.Item>
              <Descriptions.Item label="所属UET">
                <Item name="uetName" style={{ marginBottom: 0 }}>
                  <ShowInput />
                </Item>
              </Descriptions.Item>
              <Descriptions.Item label="关联回路">
                <Item name="relationCircuitList" style={{ marginBottom: 0 }}>
                  <ShowInput />
                </Item>
              </Descriptions.Item>
            </Descriptions>

            <div className={styles.preview}>
              <div className={styles.previewBtn} style={{ marginTop: 16, marginBottom: 8 }}>
                查看图标
              </div>

              <div className={styles.iconWrapper}>
                <div className={styles.iconBox}>
                  <div className={styles.icon} />
                  <Item noStyle dependencies={['name']}>
                    {({ getFieldValue }) => <div className={styles.iconText}>{getFieldValue('name')}</div>}
                  </Item>
                </div>
              </div>
            </div>
          </Form>
        </Spin>
      </Drawer>
    </div>
  );
};

export default GridAccessPointDrawer;
